module.exports = __webpack_public_path__ + "static/media/media-3.0d4253d0.png";